import { z } from 'zod';
import { GENERAL_KNOWLEDGE_CATEGORIES, TOURISM_KNOWLEDGE_CATEGORIES } from './knowledge.js';
/**
 * Industry profiles (ADR-023, spec 10 §4): `tenants.industry_profile` switches
 * industry-specific data and features on per tenant. Existing tenants are
 * `tourism`, new tenants `general`. The database CHECK on the column lists
 * the same values.
 */
export const INDUSTRY_PROFILES = ['tourism', 'general'];
export const DEFAULT_INDUSTRY_PROFILE = 'general';
export const industryProfileSchema = z.enum(INDUSTRY_PROFILES);
export const INDUSTRY_PROFILE_REGISTRY = {
    // Exactly what every tenant had before ADR-023, so Waldrand behaves as before.
    tourism: {
        knowledgeCategories: TOURISM_KNOWLEDGE_CATEGORIES,
        seeds: { contentPillars: 'tourism', qualityRules: 'tourism' },
        features: { apartments: true, seasons: true },
        entryKinds: ['person', 'apartment', 'place', 'product', 'service', 'other'],
        defaultEntryTypes: [
            { kind: 'apartment', name: 'Wohnung', name_plural: 'Wohnungen', position: 0, rotation_days: 60 },
            { kind: 'person', name: 'Person', name_plural: 'Team', position: 1, rotation_days: null },
        ],
        aiFraming: 'a holiday rental business that hosts guests in its holiday apartments',
    },
    general: {
        knowledgeCategories: GENERAL_KNOWLEDGE_CATEGORIES,
        seeds: { contentPillars: 'general', qualityRules: 'general' },
        features: { apartments: false, seasons: false },
        entryKinds: ['person', 'place', 'product', 'service', 'other'],
        defaultEntryTypes: [
            { kind: 'person', name: 'Person', name_plural: 'Team', position: 0, rotation_days: null },
            { kind: 'service', name: 'Leistung', name_plural: 'Leistungen', position: 1, rotation_days: null },
            { kind: 'place', name: 'Standort', name_plural: 'Standorte', position: 2, rotation_days: null },
        ],
        aiFraming: 'a small business',
    },
};
/** Whether `profile` offers `category` for new or changed knowledge (spec 20 §4). */
export function profileOffersCategory(profile, category) {
    return INDUSTRY_PROFILE_REGISTRY[profile].knowledgeCategories.includes(category);
}
export function profileOffersFeature(profile, feature) {
    return INDUSTRY_PROFILE_REGISTRY[profile].features[feature];
}
export function profileOffersEntryKind(profile, kind) {
    return INDUSTRY_PROFILE_REGISTRY[profile].entryKinds.includes(kind);
}
//# sourceMappingURL=industry-profiles.js.map